import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { Localizer } from "@/main/react/Types";

/**
 * The publish acknowledgement (first-session loop D3, D12 / A23 of the 2026-09-13 unbuilt-designs work
 * order; `designs/01-now/2026-07-25-first-session-loop-connect-before-create-design.md` §4.3.1).
 *
 * <p>One line, once, at the top of the author's post page right after the redirect: the post is live,
 * and the two things worth doing next. No confetti, no timer, no counts. The queued flag it renders
 * from is the existing `?sv_m=post_publish|first_post` one-shot `DiscussionPage` already consumes for
 * the share moment and the hand-off card; the parameter is stripped before anything acts, so a reload
 * never shows this again and nothing here can fail after the redirect (there is no fetch).
 *
 * <p>The close control reuses `shared.dialog.close` and hides the line locally; that is all it does.
 */
export function PublishedAcknowledgement(props: { localizer: Localizer; onClose: () => void }) {
    const { localizer, onClose } = props;
    return (
        <div
            role="status"
            data-playwright-id="published-ack"
            className="mb-4 flex items-center justify-between gap-3 rounded-xl border border-border bg-card px-4 py-3 text-sm text-text-main"
        >
            <span>{localizer("discussion.published.ack")}</span>
            <Button
                type="button"
                variant="ghost"
                size="icon-touch"
                className="text-muted-foreground hover:text-text-main"
                aria-label={localizer("shared.dialog.close")}
                data-playwright-id="published-ack-close"
                onClick={onClose}
            >
                <X className="size-4" aria-hidden="true" />
            </Button>
        </div>
    );
}

export default PublishedAcknowledgement;
